import React from 'react';

type Variant = 'primary' | 'secondary' | 'danger' | 'ghost';
type Size = 'sm' | 'md';

const VARIANTS: Record<Variant, string> = {
    // Bold tier: ink border + press shadow — the deliberate brand accent.
    primary: 'press border-2 border-[#0a0a0a] bg-[#22c55e] text-[#0a0a0a]',
    secondary: 'press border-2 border-[#0a0a0a] bg-white text-[#0a0a0a]',
    danger: 'press border-2 border-[#0a0a0a] bg-[#fb7185] text-[#0a0a0a]',
    // Soft tier: quiet tertiary action for dense screens — no border/shadow.
    ghost: 'border border-transparent bg-transparent text-[#4f4f48] hover:bg-[#ece8db] hover:text-[#0a0a0a]',
};

const SIZES: Record<Size, string> = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-4 py-2.5',
};

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: Variant;
    size?: Size;
}

/**
 * Button. Primary/secondary/danger carry the bold neobrutalist treatment
 * (ink border + press shadow) for earned emphasis; `ghost` is the quiet
 * option for repeated/tertiary actions in dense dashboard views.
 */
export const Button: React.FC<ButtonProps> = ({variant = 'primary', size = 'md', className = '', children, ...rest}) => (
    <button
        {...rest}
        className={`inline-flex items-center justify-center gap-2 rounded-xl font-bold transition-all disabled:cursor-not-allowed disabled:opacity-50 ${SIZES[size]} ${VARIANTS[variant]} ${className}`}
    >
        {children}
    </button>
);

export default Button;
